import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import { makeStyles, withStyles } from "@material-ui/core";
import { grey600, grey800 } from "material-ui/styles/colors";
import { useSelector } from "react-redux";
import EDocumentVerfication from "./_document_inprogress";
import EDocumentError from "./_document_error";
import ETechnicalSurvey from "../../e_application_review/_application_review";
import { SnackbarProvider } from "notistack";
import StepContent from "@material-ui/core/StepContent";
import EMeterInstallation from "../../e_meter-installation/view/e_meter-installtin-progress";
import EMeterInstallationSuccess from "../../e_meter-installation/view/e_meter-installation-success";
import EApplicationFee from "../../e_application_fee/_application_fee";
import ESiteSurvey from "../../e_site_survey/_site_survey";
import EApplicationReview from "../../e_application_review/_application_review";
import ECancelled from "../../e_meter-installation/_cancelled";
import ESecurityDeposit from "../../e_security-deposit/_security-deposit";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";
import ECompleted from "../../e_meter-installation/_completed";
import EPaymentReceived from "../../e_application_fee/_payment_received";

export const OutlinedTextFiled = withStyles((theme) => ({
  root: {
    "& .MuiOutlinedInput-input": {
      padding: "0.5rem !important",
      fontSize: "small",
      backgroundColor: theme?.palette?.eWhite?.base,
      fontWeight: "bold",
      color: theme?.palette?.eRich?.base,
    },
    "& .MuiFormHelperText-root.Mui-error": {
      margin: "0 !important",
    },
  },
}))(TextField);
const useStyles = makeStyles((theme) => ({
  root: {
    align: "center",
    [theme.breakpoints.up("md")]: {
      width: "90%",
    },

    "& .MuiStepIcon-completed": {
      color: theme?.palette?.eSecondary?.base + "!important",
    },
    "& .MuiStepIcon-active": {
      color: theme?.palette?.eTertiary?.base + "!important",
    },
    "& .MuiStepConnector-lineHorizontal": {
      marginTop: 7,
      marginLeft: 10,
      marginRight: 10,
    },
    "& .MuiStep-horizontal": {
      // paddingLeft:0 + "!important"
    },
    "& .MuiStepIcon-text": {
      fill: grey800,
    },

    "& .MuiStepIcon-active .MuiStepIcon-text": {
      fill: "white",
    },
    "& .MuiStepIcon-completed .MuiStepIcon-text": {
      fill: "white",
    },
    "& .MuiStepLabel-label.MuiStepLabel-completed": {
      color: grey600,
    },
  },
  asterisk: {
    color: theme.palette.eDanger?.dark,
  },
  stepLabel: {
    border: 10,
    fontSize: "small",
    "& .MuiStepLabel-label.MuiStepLabel-alternativeLabel": {
      marginTop: 6,
    },
    "& .MuiStepLabel-active": {
      color: theme?.palette?.eTertiary?.base + "!important",
    },
    "& .MuiStepLabel-completed": {
      color: theme?.palette?.eSecondary?.base + "!important",
    },
    "& .MuiSvgIcon-root": {
      fontSize: 40,
    },
  },
  stepLabelFont: {
    fontSize: "small",
  },
  textfield: {
    paddingTop: "2%",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "2% !important",
    },
    [theme.breakpoints.up("sm")]: {
      paddingLeft: "8% !important ",
    },
  },
  pp: {
    "& .MuiStepper-root": {
      padding: "0% !important",
    },
    align: "center",
  },
  mm: {
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "2% !important",
    },
    [theme.breakpoints.up("sm")]: {
      paddingLeft: "8% !important ",
    },
  },
}));
export default function TrackingStepperMobile({ response, trackingCaseId,documentsUploaded }) {
  const { t: titlelabels, ready: titlelabelsReady } = useTranslation(
    "label-NESCO_TRACK_REQUEST"
  );
  const { t: Succes, ready: succesReady } = useTranslation("label-E_CONFIRMATION_SCREEN");
  const snackBarTimeOut = 3000;
  const snackBarMaxCount = 3;
  const [accountId, setAccountId] = useState();
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const { t: labels, ready: labelReady } = useTranslation(
    "label-E_TRACKING_NEW_CONNECTION"
  );
  const { t: content, ready: contentReady } = useTranslation(
    "content-E_TRACK_CONNECTION_REQUEST"
  );
  
  let ICXNC1="ICXNC1";
  let ICXNC2="ICXNC2";
  let ICXNC3="ICXNC3";
  let ICXNC4="ICXNC4";
  let ICXNC5="ICXNC5";
  let ICXNC6="ICXNC6";
  let ICXNC7="ICXNC7";
  let ICXNC8="ICXNC8";
  let ICXNC9="ICXNC9";
  let ICXNC10="ICXNC10";
  let ICXNC11="ICXNC11";
  useEffect(() => {
    if (response) {
      setAccountId(response?.accountId);
      if (response?.status === ICXNC1) {
        setActiveStep(0);
      } else if (response?.status === ICXNC2) {
        setActiveStep(1);
      } else if (response?.status === ICXNC3) {
        setActiveStep(2);
      } else if (response?.status === ICXNC4) {
        setActiveStep(3);
      } else if (response?.status === ICXNC5) {
        setActiveStep(4);
      } else if (response?.status === ICXNC6) {
        setActiveStep(5);
      } else if (response?.status === ICXNC7) {
        setActiveStep(6);
      } else if (response?.status === ICXNC8 ) {
        setActiveStep(7);
      }
      else if (response?.status === ICXNC9 ) {
        setActiveStep(8);
      }
      else if (response?.status === ICXNC10 ) {
        setActiveStep(10);
      }
    }
  }, [response]);
  const GetPage = () => {
    switch (activeStep) {
      case 0:
        return (
          <>
            {response.missingDoc ? (
              <SnackbarProvider>
                <EDocumentError documentsUploaded={documentsUploaded} response={response} trackingCaseId={trackingCaseId}/>
              </SnackbarProvider>
            ) : (
              <EApplicationFee response={response} activeStep={activeStep} trackingCaseId={trackingCaseId} />
            )}
          </>
        );
      case 1:
        return (
          <>
            {response.missingDoc ? (
              <SnackbarProvider>
                <EDocumentError documentsUploaded={documentsUploaded} response={response} trackingCaseId={trackingCaseId}/>
              </SnackbarProvider>
            ) : (
              <EPaymentReceived response={response} activeStep={activeStep} trackingCaseId={trackingCaseId} />
            )}
          </>
        );
        case 2:
          return (
            <>
              {response.missingDoc ? (
                <SnackbarProvider>
                  <EDocumentError documentsUploaded={documentsUploaded} response={response} trackingCaseId={trackingCaseId}/>
                </SnackbarProvider>
              ) : (
                <ESiteSurvey />
              )}
            </>
          );
      case 3:
        return (
          <>
            {response.missingDoc ? (
              <SnackbarProvider>
                <EDocumentError documentsUploaded={documentsUploaded} response={response} trackingCaseId={trackingCaseId}/>
              </SnackbarProvider>
            ) : (
              <EApplicationReview response={response}/>
            )}
          </>
        );
      case 4:
        return (
          <>
            {response.missingDoc ? (
              <SnackbarProvider>
                <EDocumentError documentsUploaded={documentsUploaded} response={response} trackingCaseId={trackingCaseId} />
              </SnackbarProvider>
            ) : (
              <ESecurityDeposit response={response} activeStep={activeStep} trackingCaseId={trackingCaseId} />
            )}
          </>
        );
        case 5:
          return (
            <>
              {response.missingDoc ? (
                <SnackbarProvider>
                  <EDocumentError documentsUploaded={documentsUploaded} response={response} trackingCaseId={trackingCaseId} />
                </SnackbarProvider>
              ) : (
                <EPaymentReceived response={response} activeStep={activeStep} trackingCaseId={trackingCaseId}/>
              )}
            </>
          );
        case 6:
          return (
            <>
              {response.missingDoc ? (
                <SnackbarProvider>
                  <EDocumentError  documentsUploaded={documentsUploaded} response={response} trackingCaseId={trackingCaseId}/>
                </SnackbarProvider>
              ) : (
                <EMeterInstallation />
              )}
            </>
          );
      case 7:
        return (
          <>
            {response.missingDoc ? (
              <SnackbarProvider>
                <EDocumentError documentsUploaded={documentsUploaded} response={response} trackingCaseId={trackingCaseId} />
              </SnackbarProvider>
            ) : (
              <EMeterInstallationSuccess /> 
            )}
          </>
        );
      case 8:
        return (
          <>
            {response.missingDoc ? (
              <SnackbarProvider>
                <EDocumentError  documentsUploaded={documentsUploaded} response={response}  trackingCaseId={trackingCaseId}/>
              </SnackbarProvider>
            ) : (
              <EApplicationReview response={response}/> 
            )}
          </>
        );
      default:
        return response?.missingDoc ? (
          <SnackbarProvider>
            <EDocumentError documentsUploaded={documentsUploaded} response={response} trackingCaseId={trackingCaseId} />
          </SnackbarProvider>
        ) : <ECompleted /> 
    }
  };
  const getSteps = () => {
    return [
        titlelabelsReady?  titlelabels("E_TRACKING_APPLICATION_FEE"):"",
        titlelabelsReady?  titlelabels("E_PAYMENT_RECEIPT"):"",,,
        titlelabelsReady?titlelabels("E_TRACKING_SITE_SURVEY"):"",
        titlelabelsReady? titlelabels("E_TRACKING_APPLICATION_REVIEW"):"",
        labelReady?    labels("E_SECURITYDEPOSIT") :"",
        titlelabelsReady?  titlelabels("E_PAYMENT_RECEIPT"):"",,,
      titlelabelsReady?   titlelabels("E_TRACKING_APPLICATION_REVIEW"):"",
      labelReady?labels("E_METERINSTALLATION"):"",
      `${ labelReady?labels("E_METERINSTALLATION"):""} ${succesReady? Succes("E_CONFIRMATION_CHECK_CIRCLE_FALLBACK"):""}`,
      titlelabelsReady?`${titlelabels("E_TRACKING_COMPLETE")}`:"",
    ];
  };
  const steps = getSteps();
  return (
    <>{response?.status === ICXNC11 ? <Grid container className={classes.mmm}> <ECancelled /></Grid> :
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container className={classes.textfield}>
            <Grid item xs={12}>
            {labelReady ?
                                <Typography variant="caption" className={classes.font2}>
                                    {labels("E_REFERENCE")}
                                </Typography>
                                : <Skeleton />}
            </Grid>
            <Grid item xs={12} sm={3} md={2}>
              <Typography variant="caption" className={classes.font2}>{trackingCaseId}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} className={classes.pp}>
          <Grid container className={classes.mm}>
            {response && titlelabelsReady && labelReady ? (
              <Stepper
                activeStep={activeStep}
                className={classes.root}
                orientation="vertical"
              >
                {getSteps().map((label, index) => (
                  <Step key={label}>
                    <StepLabel className={classes.stepLabel}>{label}</StepLabel>
                    <StepContent>{GetPage(activeStep)}</StepContent>
                  </Step>
                ))}
              </Stepper>
            ) : (
              <Skeleton />
            )}
            {activeStep === steps.length &&
              (response?.missingDoc ? (
                <SnackbarProvider>
                  <EDocumentError documentsUploaded={documentsUploaded} response={response} trackingCaseId={trackingCaseId}/>
                </SnackbarProvider>
              ) : response?.status === "ICXNC10" ? (
                <ECompleted />
              ) : (
                <ECancelled />
              ))}
          </Grid>
        </Grid>
      </Grid>}
    </>
  );
}
